import axios, { AxiosRequestHeaders } from 'axios';
import { apiVersion } from '../../../configuration';
import { language } from '../../services/translations';
import store from '../../store/store';
import { logout } from './login';

export type ContentType = 'application/json' | 'multipart/form-data';

const api = axios.create({});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      const dispatch = store.dispatch;
      logout(dispatch);
    }

    return Promise.reject(error);
  }
);

export default api;

export function headers(token?: string, contentType?: ContentType): AxiosRequestHeaders {
  if (token) {
    return {
      Accept: 'application/json',
      'Content-Type': contentType || 'application/json',
      Authorization: `Bearer ${token}`,
      'Language-Code': language(),
      'X-Version': apiVersion,
    };
  } else {
    return {
      Accept: 'application/json',
      'Content-Type': contentType || 'application/json',
      'Language-Code': language(),
      'X-Version': apiVersion,
    };
  }
}
